import { Link } from "react-router-dom";
import { channels } from "@/mocks/news";

export default function ChannelStrip() {
  return (
    <div className="flex items-center gap-3 overflow-x-auto no-scrollbar pb-1">
      <span className="shrink-0 flex items-center gap-1.5 text-sm font-medium text-foreground-700">
        <i className="ri-live-line text-primary-500" />
        专题频道
      </span>
      <span className="shrink-0 w-px h-4 bg-background-300" />
      {channels.map((c) => (
        <Link
          key={c.slug}
          to={`/channel/${c.slug}`}
          className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={`${c.icon} text-primary-500`} />
          {c.name}
        </Link>
      ))}
    </div>
  );
}